import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/styles';

import { getPieChartColor } from 'constants/pieChartColors';
import { bytesToGB, toPercentage } from 'services/conversions';
import NodeLinearProgress from './NodeLinearProgress/NodeLinearProgress';

const propTypes = {
  classes: PropTypes.shape({}).isRequired,
  nodes: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
};

export function UnstyledORSpaceUsageLegend({ nodes, classes }) {
  const legendBars = nodes.map((node, index) => (
    <div key={node.nodeid} className={classes.nodeLegend}>
      <div className={classes.nameAndUsage}>
        <div className={classes.nodeName}>{node.name}</div>

        <div className={classes.nodeUsage}>
          {bytesToGB(node.spaceUsed).toFixed(2)}
          GB of {bytesToGB(node.spaceTotal).toFixed(2)}
          GB
        </div>
      </div>
      <NodeLinearProgress
        variant="determinate"
        value={toPercentage(node.spaceUsed, node.spaceTotal)}
        barBackgroundColor={getPieChartColor(index)}
      />
    </div>
  ));
  return <React.Fragment>{legendBars}</React.Fragment>;
}

UnstyledORSpaceUsageLegend.propTypes = propTypes;

const styles = (theme) => ({
  nodeLegend: {
    marginTop: theme.spacing(1),
  },
  nameAndUsage: {
    display: 'flex',
    justifyContent: 'space-between',
  },
  nodeUsage: {
    color: theme.customColors.mediumGrey,
  },
});

export default withStyles(styles)(UnstyledORSpaceUsageLegend);
